// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftAlert from "components/SoftAlert";

// Image
import lock from "assets/images/illustrations/lock.png";
import AuthLayout from "views/layouts/AuthLayout";
import { useState } from "react";

import Joi from "joi";
import ApiService from "services/ApiService";
import { useNavigate, useParams } from "react-router-dom";
import ToastUtils from "utils/ToastUtils";

function ResetPassword() {
  const [alertText, setAlertText] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [pass, setPass] = useState("");
  const [verifyPass, setVerifyPass] = useState("");
  const { token } = useParams();
  const navigate = useNavigate();

  const passwordSchema = Joi.object({
    password: Joi.string().min(8).alphanum().required(),
    confirmPassword: Joi.ref("password"),
  }).unknown(true);

  const handleSetPassword = (e) => setPass(e.target.value);
  const handleSetVerifyPassowrd = (e) => setVerifyPass(e.target.value);

  const handleRegister = async () => {
    const payload = {
      password: pass,
      confirmPassword: verifyPass,
      token: token,
    };

    const { value, error } = passwordSchema.validate(payload);
    if (error) {
      console.error(error);
      setAlertText(error.message);
      setShowAlert(true);
      return;
    }

    const response = await ApiService.postData(`/auth/reset-password?token=${token}`, payload);
    if (!response) {
      ToastUtils.error("Αδυναμία δημηιουργίας κωδικού!");
      return;
    }
    ToastUtils.success("Επιτυχία δημηιουργίας κωδικού!");
    navigate("/login");
  };

  return (
    <AuthLayout
      title="Δημιουργία νέου κωδικού"
      description="Παρακαλώ πληκτρολογήστε το νέο σας κωδικό."
      illustration={{
        image: lock,
        title: "Δημιουργία νέου κωδικού πρόσβασης!",
      }}
    >
      {showAlert && (
        <SoftAlert color="error" dismissible show={false}>
          {alertText}
        </SoftAlert>
      )}
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftInput
            type="password"
            placeholder="Κωδικός"
            size="large"
            onChange={handleSetPassword}
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftInput
            type="password"
            placeholder="Επιβεβαίωηση κωδικού"
            size="large"
            onChange={handleSetVerifyPassowrd}
          />
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton
            variant="gradient"
            color="info"
            size="large"
            onClick={handleRegister}
            fullWidth
          >
            δημιουργια
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </AuthLayout>
  );
}

export default ResetPassword;
